import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export default {
    state,
    mutations,
    getters,
    actions,
    strict: process.env.NODE_ENV === 'development' ? true : false, // attention en production le strict mode doit etre désactivé
    // car il est couteux en perf
};



// WEBPACK FOOTER //
// ./src/store/default.js